import React, { Component } from 'react'
import Link from 'gatsby-link'
import netlifyIdentity from 'netlify-identity-widget'
const logo = require('../../images/parsable-logo.svg')

class GlobalNav extends Component {
  handleClick = e => {
    e.preventDefault()
    netlifyIdentity.open()
  }
  render() {
    const currentPath =
      typeof window !== 'undefined' && window.location.pathname
    return (
      <div className="globalNav">
        <div className="container">
          <div className="row middle-md">
            <div className="col-sm-3 start-sm">
              <Link to="/" className="button button--theme_primary">
                Back
              </Link>
            </div>
            <div className="col-sm-6">
              <Link to="/" className="globalNav__brand">
                <img src={logo} />
              </Link>
            </div>
            <div className="col-sm-3 end-sm middle-sm">
              <a
                href="https://goo.gl/forms/QVM9BehpFJW6RdBx1"
                className="button button--theme_primary"
              >
                Submit Feedback
              </a>
              <Link
                to="/"
                className="button button--theme_primary"
                onClick={this.handleClick}
              >
                Profile
              </Link>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default GlobalNav



// WEBPACK FOOTER //
// ./src/components/GlobalNav/index.js